export const en = {
  titleImg: 'https://contents-virtual.eventxtra.com/uploads/reed902_staging/originals/795502bc-05df-4f3e-9feb-bcfc6581fe4a.png',
};

export const ja = {
  titleImg: 'https://contents-virtual.eventxtra.com/uploads/reed902_staging/originals/795502bc-05df-4f3e-9feb-bcfc6581fe4a.png',
};
